import { render } from "./ModeloVeiculoTrator.vue?vue&type=template&id=65e68297"
import script from "./ModeloVeiculoTrator.vue?vue&type=script&lang=ts"
export * from "./ModeloVeiculoTrator.vue?vue&type=script&lang=ts"
script.render = render

export default script